const _excluded = ["scrollContainer"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect } from 'react';
import { WideArrowUpward } from "../../icons";
import { IconButton } from "../IconButton";
import styles from "./ScrollToTopButton.module.scss";
export const ScrollToTopButton = props => {
  const {
    scrollContainer
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [showTopBtn, setShowTopBtn] = useState(false);

  const scrollToTop = () => {
    if (scrollContainer) {
      scrollContainer.scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    if (scrollContainer) {
      const onScroll = () => {
        setShowTopBtn(scrollContainer.scrollTop >= 10);
      };

      scrollContainer.addEventListener('scroll', onScroll);
      return () => {
        scrollContainer.removeEventListener('scroll', onScroll);
      };
    }
  }, [scrollContainer]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showTopBtn && /*#__PURE__*/React.createElement(IconButton, _extends({
    className: styles.goUpBtn,
    onClick: () => scrollToTop()
  }, rest), /*#__PURE__*/React.createElement(WideArrowUpward, null)));
};